import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface FlagIconProps {
  color?: string;
  isActive?: boolean;
  size?: number;
}

export default function FlagIcon({ color = '#A19F97', isActive = false, size = 24 }: FlagIconProps) {
  if (isActive) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path 
          d="M8.7314 20.9046L5.51377 5.12595L16.4675 3L15.0683 7.60703L18.0709 11.2654L7.26318 13.5509M4.09375 21H19.9045"
          fill="white"
          stroke="#151515"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path 
        d="M8.7314 20.9046L5.51377 5.12595L16.4675 3L15.0683 7.60703L18.0709 11.2654L7.26318 13.5509M4.09375 21H19.9045"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
